import { CustomComponentProps } from "utils/types/generalTypes";

export type PollItemProps = CustomComponentProps & {
    percent: number;
    option?: string;
};

const TextPollItem = ({ percent, option, className, style }: PollItemProps) => {
    return (
        <div
            className={`text-poll-item p-relative ${className} d-flex ${option ? "flex-j-between" : "flex-j-center"} flex-a-center`}
            style={style}
        >
            <div className="text-poll-bg p-absolute"></div>
            <div
                className="text-poll-fg p-absolute"
                style={{ width: `${percent}%` }}
            ></div>
            {option ? <p className="momeento-p">{option}</p> : ""}
            <p className="momeento-p">{Math.round(percent)}%</p>
        </div>
    );
};

export default TextPollItem;
